import Container from 'react-bootstrap/Container';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
// import Image from 'react-bootstrap/Image';
import Pagination from 'react-bootstrap/Pagination';
import "./HlzFactory.css";

const factoryDat = [
  {
    id: 1,
    image: require('../images/ComponentImg/Factory/ProductsShow.jpg'),
    alt: 'images/ComponentImg/Factory/ProductsShow.jpg',
    title: 'Product Show Window',
    subtitle: 'Branding'
  },
  {
    id: 2,
    image: require('../images/ComponentImg/Factory/KioskA.jpg'),
    alt: 'images/ComponentImg/Factory/KioskA.jpg',
    title: 'Touch Kiosk',
    subtitle: 'Web Design'
    // link: 'https://www.google.com',
  },
  {
    id: 3,
    image: require('../images/ComponentImg/Factory/KioskB.jpg'),
    alt: 'images/ComponentImg/Factory/KioskB.jpg',
    title: 'Touch Kiosk',
    subtitle: 'Web Design'
  },
  {
    id: 4,
    image: require('../images/ComponentImg/Factory/ProductLineA.jpg'),
    alt: 'images/ComponentImg/Factory/ProductLineA.jpg',
    title: 'Sensor Production Line',
    subtitle: 'Branding'
  },
  {
    id: 5,
    image: require('../images/ComponentImg/Factory/ProductLineB.jpg'),
    alt: 'images/ComponentImg/Factory/ProductLineB.jpg',
    title: 'Sensor Production Line',
    subtitle: 'Web Design'
  },
  {
    id: 6,
    image: require('../images/ComponentImg/Factory/ProductLineC.jpg'),
    alt: 'images/ComponentImg/Factory/ProductLineC.jpg',
    title: 'Sensor Production Line',
    subtitle: 'Branding'
  },
  {
    id: 7,
    image: require('../images/ComponentImg/Factory/ProductLineD.jpg'),
    alt: 'images/ComponentImg/Factory/ProductLineD.jpg',
    title: 'Touch Production Line',
    subtitle: 'Photography'
  },
  {
    id: 8,
    image: require('../images/ComponentImg/Factory/ProductLineE.jpg'),
    alt: 'images/ComponentImg/Factory/ProductLineE.jpg',
    title: 'Touch Production Line',
    subtitle: 'Web Design'
  },
  {
    id: 9,
    image: require('../images/ComponentImg/Factory/ProductLineF.jpg'),
    alt: 'images/ComponentImg/Factory/ProductLineF.jpg',
    title: 'Touch Cosmetic Inspection',
    subtitle: 'Branding'
  },
  {
    id: 10,
    image: require('../images/ComponentImg/Factory/ProductLineG.jpg'),
    alt: 'images/ComponentImg/Factory/ProductLineG.jpg',
    title: 'Touch Production Line',
    subtitle: 'Branding'
  },
]

// {
//   id: 8,
//   image: require('../images/ComponentImg/Factory/img9.jpg'),
//   title: 'Appreciation',
//   subtitle: 'Photography'
// },
// {
//   id: 9,
//   image: require('../images/ComponentImg/Factory/img2.jpg'),
//   title: 'Happy Days',
//   subtitle: 'Web Design'
//   link: 'https://www.google.com',
// }

let active = 3;
let items = [];
for (let number = 1; number <= 5; number++) {
  items.push(
    <Pagination.Item key={number} active={number === active}>
      {number}
    </Pagination.Item>,
  );
}

export function HlzFactory() {
  return (
    <section id='factory' className='factory-block'>
      <Container fluid>
        <div className='title-holder text-center'>
          <h2>Our Factory</h2>
          <div className='subtitle text-center'><h3>our awesome Factory</h3></div>
        </div>
        <Row className='portfolio'> {
          factoryDat.map(factory => {
            return (
              <Col sm={4} key={factory.id}>
                <div className='factory-table'>
                  <a href={factory.link}>
                    <img src={factory.image} className='mt-5 mt-lg-0' alt="" />
                    <h5>{factory.alt}</h5>
                    <div className='label text-center'>
                      <h3>{factory.title}</h3>
                      <p>{factory.subtitle}</p>
                    </div>
                  </a>
                </div>
              </Col>
            );
          })
        } </Row>
        {/* <Pagination>{items}</Pagination> */}
      </Container>
    </section>
  );
}

/*
<div className='factory-table'>
  <a href={factory.link}>
    <img src={factory.image} className='mt-5 mt-lg-0' alt="" />
    // <Image src={factory.image} className='vh-80'/>
    <div className='label text-center'>
      <h3>{factory.title}</h3>
      <p>{factory.subtitle}</p>
    </div>
  </a>
</div>
*/
